import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { WEBSITE_DATA, CURRENT_DOMAIN, TYPES } from "../../constants/dashboard";
import BackArrow from "../../assets/backArrow.svg";
import Carousel from "../Carousel";
import "./style.css";

const CP = () => {
  const navigate = useNavigate();
  const cpData = WEBSITE_DATA?.innderComponents[0]?.components[0];

  const onClickNavigate = (link, prototypeLink) => {
    navigate(link, { state: { prototypeLink } });
  };

  return (
    <>
      <div className="head">
        <img
          src={BackArrow}
          className="back"
          alt="back"
          onClick={() => navigate("/")}
        />
        <img id="img" src={WEBSITE_DATA?.logo} alt="title" />
      </div>
      <div className="data">
        <h2 className="heading1">
          {cpData?.headingPart1 && (
            <span className="head1">{cpData?.headingPart1}</span>
          )}{" "}
          <span className="head2">{cpData?.headingPart2}</span>
        </h2>
        <p className="subhead">{cpData?.subHeading}</p>
        {cpData?.componentCP
          .filter((a) => a?.domains?.includes(CURRENT_DOMAIN))
          .map((b, idx) => (
            <span key={idx}>
              {b?.type === TYPES.CARD_MEDIA_CAROUSEL && (
                <div className="carousel">
                  <h2 className="heading">{b?.heading}</h2>
                  <p className="subhead">{b?.subHeading}</p>
                  <Carousel imageList={b?.dataList} />
                </div>
              )}

              {b?.type === TYPES.CARD_MEDIA_IMG && (
                <div className="activity">
                  <h2 className="heading">{b.heading}</h2>
                  <p className="subhead">{b.subHeading}</p>
                  <div
                    className={`${
                      b.dataList.length > 1 ? "imagesContainer" : ""
                    }`}
                  >
                    {b?.dataList.map((m, idx) =>
                      m?.img ? (
                        <div key={idx} className="image">
                          <Link to={m.link} key={idx}>
                            <img src={m.img} key={idx} alt="activity" />
                          </Link>
                        </div>
                      ) : (
                        <></>
                      )
                    )}
                  </div>
                </div>
              )}

              {b?.type === TYPES.CARD_LINK && (
                <div className="student">
                  <h2 className="heading">{b.heading}</h2>
                  <p className="subhead">{b.subHeading}</p>
                  <div
                    role="presentation"
                    className="image"
                    onClick={() =>
                      onClickNavigate(b?.link, b?.dataList[0]?.link)
                    }
                  >
                    <img src={b?.img} alt="sa-img" />
                  </div>
                </div>
              )}
            </span>
          ))}

        <div className="explore">
          <h1 className="heading">
            {cpData?.componentCP[cpData?.componentCP?.length - 1].heading}
          </h1>
          <div className="card-links">
            {cpData?.componentCP[cpData?.componentCP?.length - 1].dataList
              .filter((a) => a?.domains?.includes(CURRENT_DOMAIN))
              .map((b, idx) => (
                <div key={idx} className="images">
                  {b?.type === TYPES.CARD_LINK && (
                    <Link to={b?.link}>
                      <img src={b?.img} alt="sa-img" className="image" />
                    </Link>
                  )}
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default CP;
